import React, { createContext, useContext, useEffect, useState } from "react";
import { isSuccessStatus, request } from "services/ApiRequest";
import URLs from "constants/URLs";

const ShakhsSherkatContext = createContext();

const ShakhsSherkatProvider = ({ children }) => {
  const [defaultShakhs, setDefault] = useState({
    id: "",
    name: "",
    salMali: "",
    soratHesabPattern: "",
    shamsiToday: "",
  });
  const [serverOffset, setServerOffset] = useState(null);

  const loadDefault = async () => {
    const response = await request.GET(URLs.SETTING_DEFAULT, null);

    if (response && isSuccessStatus(response.status)) {
      setDefault({
        id: response.data.id,
        name: response.data.sherkatName,
        salMali: response.data.salMali,
        soratHesabPattern: response.data.soratHesabPattern,
        shamsiToday: response.data.shamsiToday,
      });

      const serverTimeStr = response.data.time; 
      if (serverTimeStr) {
        const [h, m, s] = serverTimeStr.split(":").map(Number);
        const now = new Date();
        const serverDate = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          h,
          m,
          s || 0,
        );
        setServerOffset(serverDate.getTime() - Date.now());
      }
    }
  };

  useEffect(() => {
    loadDefault();
  }, []);

  return (
    <ShakhsSherkatContext.Provider
      value={{ defaultShakhs, serverOffset, loadDefault }}
    >
      {children}
    </ShakhsSherkatContext.Provider>
  );
};

const useDefaultShakhsSherkat = () => useContext(ShakhsSherkatContext);

export { ShakhsSherkatProvider, useDefaultShakhsSherkat };